import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { authApi } from '../services/api';

interface User {
  id: number; name: string; email: string; phone?: string;
  business_name?: string; business_address?: string;
  facebook_page_name?: string; instagram_username?: string;
  has_facebook?: boolean; has_instagram?: boolean;
  subscription_plan?: string; subscription_status: string;
  had_trial?: boolean; trial_ends_at?: string;
  subscription_ends_at?: string; subscription_renews_at?: string;
  role: string;
  // Billing
  billing_type?: string;
  billing_first_name?: string; billing_last_name?: string;
  billing_company?: string;
  vat_number?: string; tax_code?: string;
  billing_address?: string; billing_city?: string;
  billing_zip?: string; billing_province?: string;
  sdi_code?: string; pec_email?: string;
}

interface AuthCtx {
  user: User | null; loading: boolean;
  login: (e: string, p: string) => Promise<void>;
  register: (d: any) => Promise<void>;
  logout: () => void;
  refreshUser: () => Promise<void>;
}

const AuthContext = createContext<AuthCtx | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('user_token');
    if (token) {
      authApi.me().then(r => setUser(r.data)).catch(() => localStorage.removeItem('user_token')).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email: string, password: string) => {
    const r = await authApi.login({ email, password });
    localStorage.setItem('user_token', r.data.token);
    setUser(r.data.user);
  };

  const register = async (data: any) => {
    const r = await authApi.register(data);
    localStorage.setItem('user_token', r.data.token);
    setUser(r.data.user);
  };

  const logout = () => { localStorage.removeItem('user_token'); setUser(null); };

  const refreshUser = async () => {
    try { const r = await authApi.me(); setUser(r.data); } catch {}
  };

  return <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => { const c = useContext(AuthContext); if (!c) throw new Error('no auth'); return c; };
